<template>
    <el-dialog v-model="dialogTableVisible" :width="dialogWidth">
        <img :src="'http://img.helloworldend.top/upload/' + dialogPic" style="width: 100%" loading="lazy" />
    </el-dialog>
    <button onclick="reveal()" class="reveal-button">剧透模式</button><br>
    <div id="chara_profile" class="info" v-if="chara">
        <div class="gallery" style="float:right;width:30%;" v-if="chara.img">
            <img @click="handleClick(chara.img)" :src="'http://img.helloworldend.top/upload/' + chara.img"
                style="width: 100%" loading="lazy" />
        </div>
        <h2>基本信息</h2>
        <p>姓名：{{ chara.name }}
            <el-popover :width="300"
                popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;">
                <template #reference>
                    <i class="far fa-question-circle material-icons" />
                </template>
                <template #default>
                    <p v-html="chara.nameComment" />
                </template>
            </el-popover>
        </p>
        <p v-html="chara.anotherName" />
        <p v-html="show('性别：', chara.sex)" />
        <p v-html="show('年龄：', chara.age)" />
        <p v-html="show('身高：', chara.height)" />
        <p v-html="show('特征：', chara.appearance)" />
        <p v-html="show('身份：', chara.tag)" />
        <p v-html="show('阵营：', chara.camp)" />
        <p v-html="show('喜欢：', chara.favor)" />
        <p v-html="show('讨厌：', chara.unfavor)" />
        <p v-html="show('印象：', chara.impression)" />
        <p v-html="show('关系：<br>', chara.relation)" />
    </div>
    <div id="comment" class="info" v-if="chara">
        <div v-if="chara.relationComment">
            <h2>评价</h2>
            <p v-html="show('null', chara.relationComment)" />
            <div v-if="chara.moreComment">
                <details>
                    <summary class="sum">更多[展开]</summary>
                    <p v-html="show('null', chara.moreComment)" />
                </details>
            </div>
        </div>
    </div>
    <div id="superpower" class="info" v-if="chara">
        <h2 v-if="chara.world == 'CSPA特别行动组行动报告'">异能</h2>
        <h2 v-else-if="chara.world == '泰尔兰大陆环游记'">魔法</h2>
        <p v-if="chara.world == 'CSPA特别行动组行动报告'" v-html="show('异能：', chara.superpower)" />
        <p v-else-if="chara.world == '泰尔兰大陆环游记'" v-html="show('魔法：', chara.superpower)" />
        <p v-html="show('评价：', chara.superpowerComment)" />
        <p v-if="chara.world == 'CSPA特别行动组行动报告'" v-html="show('SDS症状：', chara.superpowerSideEffect)" />
        <p v-else-if="chara.world == '泰尔兰大陆环游记'" v-html="show('魔力限制：', chara.superpowerSideEffect)" />
    </div>
    <div style="text-align:center;padding:20px;margin-top:50px">
        <h2>保存当前页面</h2>
        <p>使用功能前请将所有折叠信息展开，否则会导致文字重叠</p>
        <button class="capture-button" onclick="capture('#chara_profile','#captureResult')">基本信息</button>
        <button class="capture-button" onclick="capture('#comment','#captureResult')">他人评价</button>
        <button class="capture-button" onclick="capture('#superpower','#captureResult')">能力信息</button>
        <br>
        <img id="captureResult" style="width:100%">
    </div>
</template>
<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import service from '../utils/request'

let route = useRoute()
const title = route.params.name[0]
const dialogTableVisible = ref(false)
const dialogPic = ref()
const dialogWidth = ref(0)
const chara = ref()
const articles = []

const prop = defineProps({
    charas: {
        type: Object,
        default: {}
    },
    articles: {
        type: Object,
        default: {}
    }
})

const getData = (name) => {
    const requestData = {
        column: 'name',
        value: name
    };
    service.post("/user/chara/listDetail", requestData)
        .then(res => {
            const rst = res.data;
            if (rst.length != 0 && rst[0] != null) {
                chara.value = rst[0];
            } else {
                console.error('返回简介信息为空', error);
            }
        }).catch(error => {
            console.error('获取简介信息失败', error);
        });
}


function show(prefix, content) {
    if (content) {
        if (!content.includes(prefix) && prefix != "null") {
            return prefix + content;
        }
        else {
            return content;
        }
    }
}

function replaceKeywords(keywords, type) {
    const validKeywords = keywords.filter(keyword => typeof keyword === 'string' && keyword.trim() !== '');
    if (validKeywords.length === 0) {
        return;
    }

    function escapeRegExp(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    const keywordStr = validKeywords.map(escapeRegExp).join('|');
    const regex = new RegExp(`(${keywordStr})`, 'gi');

    function doReplace() {
        const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, function (node) {
            const parentTag = node.parentElement ? node.parentElement.tagName.toLowerCase() : '';
            const excludeTags = ['script', 'style', 'textarea', 'input', 'select', 'option', 'a', 'svg', 'canvas'];
            return excludeTags.includes(parentTag) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        });

        const textNodes = [];
        let currentNode;
        while (currentNode = walker.nextNode()) {
            if (currentNode.parentNode && currentNode.textContent.trim()) {
                textNodes.push(currentNode);
            }
        }

        textNodes.forEach(node => {
            const originalText = node.textContent;
            const parent = node.parentNode;
            if (!parent) return;

            if (regex.test(originalText)) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = originalText.replace(regex, function (match) {
                    const link = document.createElement('a');
                    if (type == "article") {
                        link.href = `/article/${match}`;
                    } else if (type == "chara") {
                        link.href = `/chara/${match}/profile`;
                    }
                    link.target = '_blank';
                    link.textContent = match;
                    return link.outerHTML;
                });

                while (tempDiv.firstChild) {
                    parent.insertBefore(tempDiv.firstChild, node);
                }
                parent.removeChild(node);
            }
        });
    }

    window.addEventListener('load', doReplace);

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(mutation => {
            if (mutation.addedNodes.length > 0) {
                setTimeout(doReplace, 0);
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
    });
}

onMounted(() => {
    getData(title);
})

watch(
    () => prop.charas,
    (newVal, oldVal) => {
        if (newVal) {
            const charaList = Object.values(prop.charas).filter(item => item !== title);
            replaceKeywords(charaList, 'chara');
        }
    },
    {
        immediate: true // 可选：组件初始化时立即执行一次（若初始 props 已非空，直接触发）
    }
);

function reveal() {
    var list = document.querySelectorAll(".mask");
    var rel = [];
    var i;
    if (list) {
        c = list[0].style.color;
    }
    for (i = 0; i < list.length; ++i) {
        if (c != "white") {
            list[i].style.color = 'white';
            var a = list[i].getElementsByTagName("a");
            if (a) {
                var j;
                for (j = 0; j < a.length; ++j) {
                    a[j].style.color = "skyblue";
                }
            }
        } else {
            list[i].style.color = 'black';
            var a = list[i].getElementsByTagName("a");
            if (a) {
                var j;
                for (j = 0; j < a.length; ++j) {
                    a[j].style.color = "black";
                }
            }
        }
    }
}

function capture(selector1, selector2) {
    var element = document.querySelector(selector1);
    //要显示图片的img标签
    var image = document.querySelector(selector2);
    //调用html2image方法
    const mark = document.querySelector('.mask');
    if (element) {
        if (mark) {
            var bgColor = getComputedStyle(mark).backgroundColor;
            var text = mark.textContent;
            const arrTextNode = text.split('').map(char => {
                var span = document.createElement('span');
                span.textContent = char;
                span.style.backgroundColor = bgColor;
                span.style.color = "#ffffff";
                return span;
            });
            mark.replaceWith.apply(mark, arrTextNode);
        }
        html2image(element, image);
    }
    function html2image(element, image) {
        html2canvas(element).then(function (canvas) {
            var imageData = canvas.toDataURL(1);
            //此时图片已经可以显示了
            image.src = imageData;
        });
    }

}

const handleClick = (item) => {
    dialogTableVisible.value = true
    dialogPic.value = item;
    setDialogWidth()
}

const setDialogWidth = () => {
    var val = document.body.clientWidth
    const def = 800 // 默认宽度
    if (val < def) {
        dialogWidth.value = '95%'
    } else {
        dialogWidth.value = def + 'px'
    }
}

</script>
<style scoped></style>